import type { WidgetId } from './dashboard-widgets';
import { WIDGET_REGISTRY } from './dashboard-widgets';

export interface DashboardLayout {
  order: WidgetId[];
  hidden: WidgetId[];
}

const STORAGE_KEY = 'tallow-admin-dashboard-layout';

const DEFAULT_ORDER: WidgetId[] = WIDGET_REGISTRY.map(w => w.id);

export function loadLayout(): DashboardLayout {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { order: [...DEFAULT_ORDER], hidden: [] };
    const parsed = JSON.parse(raw) as DashboardLayout;
    const allIds = new Set(WIDGET_REGISTRY.map(w => w.id));
    const order = (parsed.order ?? []).filter((id: string) => allIds.has(id as WidgetId)) as WidgetId[];
    const hidden = (parsed.hidden ?? []).filter((id: string) => allIds.has(id as WidgetId)) as WidgetId[];
    for (const id of DEFAULT_ORDER) {
      if (!order.includes(id) && !hidden.includes(id)) order.push(id);
    }
    return { order, hidden };
  } catch {
    return { order: [...DEFAULT_ORDER], hidden: [] };
  }
}

export function saveLayout(layout: DashboardLayout): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(layout));
  } catch { /* localStorage unavailable */ }
}
